/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fw_Faq_A2Inputs */

const en_fw_faq_a2 = /** @type {(inputs: Fw_Faq_A2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schedule trackers list 12 episodes of about 23 minutes each. The official site has not confirmed a final count.`)
};

const zh_fw_faq_a2 = /** @type {(inputs: Fw_Faq_A2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`排期站列出共 12 话、每话约 23 分钟，官方尚未确认最终话数。`)
};

/**
* | output |
* | --- |
* | "Schedule trackers list 12 episodes of about 23 minutes each. The official site has not confirmed a final count." |
*
* @param {Fw_Faq_A2Inputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const fw_faq_a2 = /** @type {((inputs?: Fw_Faq_A2Inputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fw_Faq_A2Inputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_fw_faq_a2(inputs)
	return zh_fw_faq_a2(inputs)
});
export { fw_faq_a2 as "fw.faq.a2" }